import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Verified from "../icons/Verified";
import { saveAs } from "file-saver";

const ViewDetails = () => {
  const { id } = useParams();
  const nav = useNavigate();
  const [requestDetails, setRequestDetails] = useState({});
  useEffect(() => {
    if (id) {
      (async () => {
        const data2 = await fetch(
          process.env.REACT_APP_API_URL + "view-request/" + id
        );
        const editDetails = await data2.json();
        console.log("editDetails", editDetails);
        setRequestDetails(editDetails.data);
        if (editDetails.status === true) {
          // success
        } else {
          nav("/admin/verification-requests");
        }
      })();
    }
  }, [nav, id]);

  const updateRequestStatus = async (e) => {
    let obj = {
      status: e,
      _id: id,
      userId: requestDetails.userId,
    };
    let text = "";
    let button = "";
    if (e === 1) {
      text = "Are You sure you want to pending this request!";
      button = "Yes";
    } else if (e === 2) {
      text = "Are You sure you want to put on hold this request!";
      button = "Yes";
    } else if (e === 3) {
      text = "Are You sure you want to approve this request!";
      button = "Yes";
    } else if (e === 4) {
      text = "Are You sure you want to reject this request!";
      button = "Yes";
    }
    Swal.fire({
      title: "Are you sure?",
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: button,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            process.env.REACT_APP_API_URL + "request-update",
            {
              method: "POST",
              body: JSON.stringify(obj),
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          const result = await response.json();
          if (result.status === true) {
            let newDetails = { ...requestDetails };
            newDetails.verification_status = e;
            // newDetails.updateDate = new Date();
            setRequestDetails(newDetails);
          } else {
            // error message
          }
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const downloadDocument = async (e) => {
    await fetch(e.target.href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", requestDetails.document); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4 flex-wrap">
            <h4 className="fs-20 font-w600  me-auto">
              User Verification Request
            </h4>
          </div>
          <div className="row">
            <div className="col-xl-3 col-xxl-4">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header border-0 pb-0 d-block">
                      <div className="d-flex justify-content-between">
                        <h4 className="fs-20 mb-0">User Details</h4>
                        {requestDetails.verification_status === 3 && (
                          <Verified />
                        )}
                        {requestDetails.verification_status === 4 && (
                          <button className="btn btn-danger btn-sm">Rejected</button>
                        )}
                      </div>
                    </div>
                    <div className="card-body pt-4">
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">Name:</h5>
                        <span>{requestDetails.name}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">Email:</h5>
                        <span>{requestDetails.email}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">Username:</h5>
                        <span>{requestDetails.username}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">
                          Registered On:
                        </h5>
                        <span>{requestDetails.registerDate}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">
                          Social Links:
                        </h5>
                        <span>{requestDetails.socialLinks}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">
                          Other Links:
                        </h5>
                        <span>{requestDetails.otherLinks}</span>
                      </div>
                      <hr />
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">
                          Requested On:
                        </h5>
                        <span>{requestDetails.createDate}</span>
                      </div>
                      <div className="mb-3 d-flex">
                        <h5 className="mb-1 fs-14 custom-label">
                          Req. Updated On:
                        </h5>
                        <span>{requestDetails.updateDate}</span>
                      </div>
                    </div>
                    <div className="card-footer border-0 pt-0 ">
                      <div className="d-flex justify-content-between flex-wrap">
                        {requestDetails.verification_status === 3 && (
                          <button
                            className="btn btn-primary btn-sm mb-3"
                            onClick={() => updateRequestStatus(1)}
                          >
                            <i className="fas fa-clock me-2 " />
                            Pending
                          </button>
                        )}
                        {requestDetails.verification_status === 1 && (
                          <React.Fragment>
                            <button
                              className="btn btn-primary btn-sm mb-3"
                              onClick={() => updateRequestStatus(3)}
                            >
                              <i className="fas fa-check me-2 " />
                              Verify
                            </button>
                            <button
                              className="btn btn-warning btn-sm mb-3"
                              onClick={() => updateRequestStatus(4)}
                            >
                              <i className="fas fa-xmark me-2" />
                              Reject
                            </button>
                            <button
                              className="btn btn-secondary btn-sm mb-3"
                              onClick={() => updateRequestStatus(2)}
                            >
                              <i className="fas fa-cancel me-2" />
                              On-Hold
                            </button>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 col-xxl-8">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-header d-block">
                      <div className="d-flex justify-content-between">
                        <h4 className="fs-20 d-block">Requested Details</h4>
                        {/* <a
                          className="btn btn-success btn-sm"
                          href={
                            process.env.REACT_APP_IMAGE_URL +
                            "documents/" +
                            requestDetails.document
                          }
                          download
                          onClick={(e) => downloadDocument(e)}
                          target={"_blank"}
                          rel="noreferrer"
                          // onClick={() =>
                          //   downloadDocument(
                          //     process.env.REACT_APP_IMAGE_URL +
                          //       "documents/" +
                          //       requestDetails.document
                          //   )
                          // }
                        >
                          <i className="fas fa-download" />
                        </a> */}
                      </div>
                    </div>
                    <div className="card-body">
                      <h4 className="fs-20 mb-3">Full Name</h4>
                      {requestDetails.fullName}
                      <hr />
                      <h4 className="fs-20 mb-3">Document</h4>
                      <div className="row mb-3">
                        <img
                          src={
                            process.env.REACT_APP_IMAGE_URL +
                            "documents/" +
                            requestDetails.document
                          }
                          alt="no"
                        />
                      </div>
                      <div className="d-flex justify-content-between py-4 border-bottom border-top flex-wrap">
                        <span>Request ID: #{requestDetails.requestId}</span>
                        <span>
                          Requested By <strong>User</strong>/
                          {requestDetails.createDate}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewDetails;
